import { getCurrentUserId } from "@risalabs_frontend_org/auth-wrapper";
import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import React, { useState } from "react";
import { Modal } from "risa-oasis-ui_v2";
import { killSwitch } from "../../../../shared/api/postCall/killSwitch";
import { ModalId } from "../../../../shared/enums/modalId";
import WarningIcon from "../../../../shared/svg/warningIcon";
import { ToastMessages } from "../../toasts/toastMessages";

interface ToggleSwitchConfirmationDialogProps {
  clientId: string;
  onClose: () => void;
  onConfirm?: () => void;
  metaData?: {
    id?: string;
    switchState?: boolean;
  };
}

const ToggleSwitchConfirmationDialog: React.FC<
  ToggleSwitchConfirmationDialogProps
> = ({ onClose, onConfirm, clientId, metaData }) => {
  const [comments, setComments] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const isEnabling = metaData?.switchState === true;

  const handleConfirm = async () => {
    setLoading(true);
    const userId = getCurrentUserId();
    try {
      const payload = {
        grid_identifier: metaData?.id || "",
        client_id: clientId,
        agent_mode: isEnabling,
        remarks: comments,
        user_id: userId ?? "",
      };
      const response = await killSwitch(payload);

      if (response.success) {
        toast.success(ToastMessages.KILL_SWITCH_SUCCESS);
        onConfirm?.();
      } else {
        toast.error(ToastMessages.KILL_SWITCH_FAILURE);
        onClose();
      }
    } catch (error) {
      console.error("Error confirming toggle switch:", error);
      toast.error(ToastMessages.KILL_SWITCH_FAILURE);
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      dialogId={ModalId.TOGGLE_SWITCH_CONFIRMATION_DIALOG}
      title={isEnabling ? "Enable Automation" : "Remove Automation"}
      onCancel={onClose}
      onClose={onClose}
      onSave={handleConfirm}
      cancelText="Cancel"
      saveButtonText={loading ? "Confirming..." : "Confirm"}
      disableSave={!comments || loading}
    >
      <div className="toggle-switch-confirmation-content flex flex-col gap-4">
        <div
          className={`warning-icon-automation flex flex-row items-center gap-2 bg-red-50 p-2`}
        >
          <WarningIcon outerFillColor="black" height="16" width="16" />
          <div className="text-small font-normal">
            {isEnabling
              ? `This will enable Agent Mode`
              : `This will pause drug from Agent Mode`}
          </div>
        </div>
        <div className="comments-section w-full">
          <div className="comments-section header mb-2 text-small font-normal text-primaryGray-2">
            {isEnabling
              ? "Please provide the reason for enabling Agent Mode."
              : "Please provide the reason for shifting drug to Human."}
          </div>
          <div className="comments-section comments-textarea">
            <textarea
              className="h-20 w-full rounded-md border border-gray-300 p-2 text-tiny font-normal"
              placeholder=""
              onChange={(e) => setComments(e.target.value)}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ToggleSwitchConfirmationDialog;
